import { getProducts } from "../dataSourceIntegrationService";
import { MAPPING_ISO_CODE, ICONS } from "../constants";
import * as R from "ramda";

const locations = {
  "Miami Office": {
    name: "Miami Office",
    lat: "25.7617",
    lng: "-80.1918 ",
    color: "default",
    description: "DTone Office",
    url: "default"
  },
  Dubai: {
    name: "Dubai Office",
    lat: "25.0657",
    lng: "55.17128",
    color: "green",
    description: "DTone Office",
    url: "default"
  },

  Singapore: {
    name: "Singapore Office",
    lat: "1.28967",
    lng: "103.85007",
    color: "blue",
    description: "DTone Office",
    url: "default"
  },
  Salvador: {
    name: "Salvador Office",
    lat: "13.7942",
    lng: "-89.18718",
    color: "blue",
    description: "Dtone Office",
    url: "default"
  }
};

const all_labels = {
  AF: {
    parent_id: "AF",
    x: "1340.9",
    y: "284.0"
  },
  AO: {
    parent_id: "AO",
    x: "1087.3",
    y: "578.3"
  },
  AL: {
    parent_id: "AL",
    x: "1085.4843",
    y: "252.91448"
  },
  AE: {
    parent_id: "AE",
    x: "1318.2483",
    y: "387.0558"
  },
  AR: {
    parent_id: "AR",
    x: "641.1",
    y: "726.7"
  },
  AM: {
    parent_id: "AM",
    x: "1249.3446",
    y: "230.38275"
  },
  AU: {
    parent_id: "AU",
    x: "1722.9",
    y: "654.9"
  },
  AT: {
    parent_id: "AT",
    x: "1060",
    y: "195.39999"
  },
  AZ: {
    parent_id: "AZ",
    x: "1255.9362",
    y: "253.01473"
  },
  BI: {
    parent_id: "BI",
    x: "1230.6042",
    y: "531.9326"
  },
  BE: {
    parent_id: "BE",
    x: "1000.5872",
    y: "156.46957"
  },
  BJ: {
    parent_id: "BJ",
    x: "1006.3104",
    y: "471.25832"
  },
  BF: {
    parent_id: "BF",
    x: "977.8",
    y: "421.0"
  },
  BD: {
    parent_id: "BD",
    x: "1486.1",
    y: "377.62605"
  },
  BG: {
    parent_id: "BG",
    x: "1115.5988",
    y: "229"
  },
  BA: {
    parent_id: "BA",
    x: "1078.1112",
    y: "217"
  },
  BY: {
    parent_id: "BY",
    x: "1120.9",
    y: "159.9"
  },
  BZ: {
    parent_id: "BZ",
    x: "508",
    y: "392"
  },
  BO: {
    parent_id: "BO",
    x: "624.5",
    y: "609.4"
  },
  BR: {
    parent_id: "BR",
    x: "697",
    y: "563.6"
  },
  BN: {
    parent_id: "BN",
    x: "1630.6351",
    y: "449.02776"
  },
  BT: {
    parent_id: "BT",
    x: "1483.3101",
    y: "306.98369"
  },
  BW: {
    parent_id: "BW",
    x: "1120.9",
    y: "643.2"
  },
  CF: {
    parent_id: "CF",
    x: "1105.2",
    y: "457.3"
  },
  CA: {
    parent_id: "CA",
    x: "476.7",
    y: "128.3"
  },
  CH: {
    parent_id: "CH",
    x: "1016.8843",
    y: "230.84609"
  },
  CN: {
    parent_id: "CN",
    x: "1561.3",
    y: "285.0"
  },
  CI: {
    parent_id: "CI",
    x: "954.9",
    y: "453.5"
  },
  CM: {
    parent_id: "CM",
    x: "1054.5",
    y: "472.5"
  },
  CD: {
    parent_id: "CD",
    x: "1118.9",
    y: "516.9"
  },
  CG: {
    parent_id: "CG",
    x: "1024.6354",
    y: "547.97398"
  },
  CO: {
    parent_id: "CO",
    x: "572",
    y: "477.7"
  },
  CR: {
    parent_id: "CR",
    x: "486.70425",
    y: "437.18263"
  },
  CU: {
    parent_id: "CU",
    x: "529.70428",
    y: "370.93144"
  },
  CZ: {
    parent_id: "CZ",
    x: "1059",
    y: "180.95412"
  },
  DE: {
    parent_id: "DE",
    x: "1033.9",
    y: "173.1"
  },
  DJ: {
    parent_id: "DJ",
    x: "1243.6635",
    y: "422.68413"
  },
  DK: {
    parent_id: "DK",
    x: "999",
    y: "129"
  },
  DO: {
    parent_id: "DO",
    x: "603.61914",
    y: "396.72792"
  },
  DZ: {
    parent_id: "DZ",
    x: "1001.4",
    y: "325.3"
  },
  EC: {
    parent_id: "EC",
    x: "544.29999",
    y: "507.79997"
  },
  EG: {
    parent_id: "EG",
    x: "1147.5",
    y: "333.0"
  },
  ER: {
    parent_id: "ER",
    x: "1208.9813",
    y: "386.41841"
  },
  EE: {
    parent_id: "EE",
    x: "1141.457",
    y: "121.18745"
  },
  ET: {
    parent_id: "ET",
    x: "1205.6",
    y: "448.7"
  },
  FI: {
    parent_id: "FI",
    x: "1102.5",
    y: "104.8"
  },
  GA: {
    parent_id: "GA",
    x: "1052.7",
    y: "503.79997"
  },
  GB: {
    parent_id: "GB",
    x: "978.70001",
    y: "166.0"
  },
  GE: {
    parent_id: "GE",
    x: "1185.9564",
    y: "229.49405"
  },
  GH: {
    parent_id: "GH",
    x: "958.0683",
    y: "482.94389"
  },
  GN: {
    parent_id: "GN",
    x: "920.41785",
    y: "429.16887"
  },
  GM: {
    parent_id: "GM",
    x: "871.27081",
    y: "411.16713"
  },
  GW: {
    parent_id: "GW",
    x: "875.42096",
    y: "432.71501"
  },
  GQ: {
    parent_id: "GQ",
    x: "1024.5679",
    y: "525.95299"
  },
  GR: {
    parent_id: "GR",
    x: "1109.8652",
    y: "260.49831"
  },
  GL: {
    parent_id: "GL",
    x: "817.7",
    y: "47.7",
    hide: "yes"
  },
  GT: {
    parent_id: "GT",
    x: "450.30508",
    y: "411.532"
  },
  GY: {
    parent_id: "GY",
    x: "670.72821",
    y: "445.36958"
  },
  HN: {
    parent_id: "HN",
    x: "500",
    y: "406"
  },
  HR: {
    parent_id: "HR",
    x: "1063.4906",
    y: "229.73637"
  },
  HT: {
    parent_id: "HT",
    x: "571",
    y: "398"
  },
  HU: {
    parent_id: "HU",
    x: "1084.7",
    y: "199.7"
  },
  ID: {
    parent_id: "ID",
    x: "1630",
    y: "508"
  },
  IN: {
    parent_id: "IN",
    x: "1419.4906",
    y: "390.54955"
  },
  IE: {
    parent_id: "IE",
    x: "926.9671",
    y: "170"
  },
  IR: {
    parent_id: "IR",
    x: "1283.3",
    y: "291.7"
  },
  IQ: {
    parent_id: "IQ",
    x: "1217.8",
    y: "288.8"
  },
  IS: {
    parent_id: "IS",
    x: "906",
    y: "94.300004"
  },
  IL: {
    parent_id: "IL",
    x: "1163.5388",
    y: "304.28038"
  },
  IT: {
    parent_id: "IT",
    x: "1041.3868",
    y: "209.37993"
  },
  JM: {
    parent_id: "JM",
    x: "545.9837",
    y: "396.72353"
  },
  JO: {
    parent_id: "JO",
    x: "1199.764",
    y: "312.63203"
  },
  JP: {
    parent_id: "JP",
    x: "1721.7",
    y: "269.8"
  },
  KZ: {
    parent_id: "KZ",
    x: "1322.8",
    y: "188.2"
  },
  KE: {
    parent_id: "KE",
    x: "1200.6",
    y: "499.0"
  },
  KG: {
    parent_id: "KG",
    x: "1376.7",
    y: "232.5"
  },
  KH: {
    parent_id: "KH",
    x: "1574.9",
    y: "418.40001"
  },
  KR: {
    parent_id: "KR",
    x: "1686.7626",
    y: "257.46883"
  },
  KW: {
    parent_id: "KW",
    x: "1253.8129",
    y: "296.88179"
  },
  LA: {
    parent_id: "LA",
    x: "1630.8213",
    y: "405.26177"
  },
  LB: {
    parent_id: "LB",
    x: "1159.1532",
    y: "287.72438"
  },
  LR: {
    parent_id: "LR",
    x: "921.68384",
    y: "477.92806"
  },
  LY: {
    parent_id: "LY",
    x: "1084.2",
    y: "330.7"
  },
  LK: {
    parent_id: "LK",
    x: "1468.8625",
    y: "468.93059"
  },
  LS: {
    parent_id: "LS",
    x: "1176.6000",
    y: "717.86321"
  },
  LT: {
    parent_id: "LT",
    x: "1140",
    y: "147"
  },
  LV: {
    parent_id: "LV",
    x: "1139.2533",
    y: "134"
  },
  MA: {
    parent_id: "MA",
    x: "948.09998",
    y: "297.7"
  },
  MD: {
    parent_id: "MD",
    x: "1144.8132",
    y: "218.31331"
  },
  MG: {
    parent_id: "MG",
    x: "1246.7",
    y: "617.90001"
  },
  MX: {
    parent_id: "MX",
    x: "421.6",
    y: "346.3"
  },
  MK: {
    parent_id: "MK",
    x: "1118",
    y: "248"
  },
  ML: {
    parent_id: "ML",
    x: "974.9",
    y: "385.3"
  },
  MM: {
    parent_id: "MM",
    x: "1521",
    y: "365.0"
  },
  ME: {
    parent_id: "ME",
    x: "1048.5807",
    y: "248.82036"
  },
  MN: {
    parent_id: "MN",
    x: "1505.1",
    y: "204.0"
  },
  MZ: {
    parent_id: "MZ",
    x: "1199.7",
    y: "597.40001"
  },
  MR: {
    parent_id: "MR",
    x: "931.7",
    y: "378.9"
  },
  MW: {
    parent_id: "MW",
    x: "1224.9875",
    y: "547.27977"
  },
  MY: {
    parent_id: "MY",
    x: "1609.2471",
    y: "470.11131"
  },
  NA: {
    parent_id: "NA",
    x: "1080.9",
    y: "632.1"
  },
  NE: {
    parent_id: "NE",
    x: "1039.1",
    y: "391.7"
  },
  NG: {
    parent_id: "NG",
    x: "1028.8",
    y: "439.5"
  },
  NI: {
    parent_id: "NI",
    x: "506.89999",
    y: "420"
  },
  NO: {
    parent_id: "NO",
    x: "1024.8",
    y: "114.9"
  },
  NP: {
    parent_id: "NP",
    x: "1445.4106",
    y: "300.67806"
  },
  OM: {
    parent_id: "OM",
    x: "1293.988",
    y: "405.07713"
  },
  PK: {
    parent_id: "PK",
    x: "1367.2057",
    y: "307.69435"
  },
  PA: {
    parent_id: "PA",
    x: "507.38751",
    y: "461.26375"
  },
  PE: {
    parent_id: "PE",
    x: "579",
    y: "587.7"
  },
  PH: {
    parent_id: "PH",
    x: "1708.293",
    y: "405.73146"
  },
  PG: {
    parent_id: "PG",
    x: "1798.2",
    y: "538.8"
  },
  PL: {
    parent_id: "PL",
    x: "1084.0332",
    y: "168.13315"
  },
  KP: {
    parent_id: "KP",
    x: "1676.2626",
    y: "237.76885"
  },
  PY: {
    parent_id: "PY",
    x: "662.71729",
    y: "651"
  },
  QA: {
    parent_id: "QA",
    x: "1326.5909",
    y: "365.14076"
  },
  RO: {
    parent_id: "RO",
    x: "1111",
    y: "208"
  },
  RW: {
    parent_id: "RW",
    x: "1246.3348",
    y: "510.31725"
  },
  EH: {
    parent_id: "EH",
    x: "874.99066",
    y: "341.4507"
  },
  SA: {
    parent_id: "SA",
    x: "1232.4",
    y: "347.0"
  },
  SD: {
    parent_id: "SD",
    x: "1152.7",
    y: "394.6"
  },
  SS: {
    parent_id: "SS",
    x: "1156.6",
    y: "456.0"
  },
  SN: {
    parent_id: "SN",
    x: "879.13733",
    y: "390.53569"
  },
  SL: {
    parent_id: "SL",
    x: "900.06958",
    y: "456.61443"
  },
  SV: {
    parent_id: "SV",
    x: "453.73883",
    y: "430.33058"
  },
  RS: {
    parent_id: "RS",
    x: "1094.1964",
    y: "218.66661"
  },
  SR: {
    parent_id: "SR",
    x: "698.64581",
    y: "451.06206"
  },
  SK: {
    parent_id: "SK",
    x: "1071.4683",
    y: "143.32436"
  },
  SI: {
    parent_id: "SI",
    x: "1054.4886",
    y: "216.42445"
  },
  SE: {
    parent_id: "SE",
    x: "1052.6",
    y: "125.40001"
  },
  SZ: {
    parent_id: "SZ",
    x: "1180",
    y: "683"
  },
  SY: {
    parent_id: "SY",
    x: "1192",
    y: "277.0"
  },
  TD: {
    parent_id: "TD",
    x: "1091.1",
    y: "404.4"
  },
  TG: {
    parent_id: "TG",
    x: "989.59564",
    y: "488.66805"
  },
  TH: {
    parent_id: "TH",
    x: "1553.4",
    y: "403.0"
  },
  TJ: {
    parent_id: "TJ",
    x: "1393.9646",
    y: "251.59685"
  },
  TM: {
    parent_id: "TM",
    x: "1294.3",
    y: "245.7"
  },
  TL: {
    parent_id: "TL",
    x: "1701.5997",
    y: "545.63542"
  },
  TN: {
    parent_id: "TN",
    x: "1049.0475",
    y: "277.63457"
  },
  TR: {
    parent_id: "TR",
    x: "1168.7",
    y: "250.0"
  },
  TW: {
    parent_id: "TW",
    x: "1686.1614",
    y: "349.49999"
  },
  TZ: {
    parent_id: "TZ",
    x: "1183.3",
    y: "541.6"
  },
  UG: {
    parent_id: "UG",
    x: "1172.4377",
    y: "489.97902"
  },
  UA: {
    parent_id: "UA",
    x: "1142.6",
    y: "185.9"
  },
  UY: {
    parent_id: "UY",
    x: "684.20001",
    y: "712.40001"
  },
  UZ: {
    parent_id: "UZ",
    x: "1310.1",
    y: "230"
  },
  VE: {
    parent_id: "VE",
    x: "622.4",
    y: "455.7"
  },
  VN: {
    parent_id: "VN",
    x: "1626.4243",
    y: "376.49745"
  },
  YE: {
    parent_id: "YE",
    x: "1243.1",
    y: "403.7"
  },
  ZM: {
    parent_id: "ZM",
    x: "1132.5",
    y: "595.90001"
  },
  ZW: {
    parent_id: "ZW",
    x: "1152.5",
    y: "621.10002"
  },
  SO: {
    parent_id: "SO",
    x: "1236.1",
    y: "479.49999"
  },
  ZA: {
    parent_id: "ZA",
    x: "1112.9",
    y: "696.1"
  },
  NZ: {
    parent_id: "NZ",
    x: "1861.7003",
    y: "755.03935"
  },
  CL: {
    parent_id: "CL",
    x: "581.35266",
    y: "727.16252"
  },
  NL: {
    parent_id: "NL",
    x: "1007.187",
    y: "142.56941"
  },
  PT: {
    parent_id: "PT",
    x: "925.76141",
    y: "246.3425"
  },
  RU: {
    parent_id: "RU",
    x: "1418.1",
    y: "115.0"
  },
  ES: {
    parent_id: "ES",
    x: "968",
    y: "244.8"
  },
  FR: {
    parent_id: "FR",
    x: "998.1",
    y: "202.5"
  },
  US: {
    parent_id: "US",
    x: "469.6",
    y: "250.6"
  },
  GF: {
    parent_id: "GF",
    x: "713.44324",
    y: "470.29247"
  },
  AS: {
    parent_id: "AS",
    x: "31.349293",
    y: "601.44872"
  },
  BH: {
    parent_id: "BH",
    x: "1279.824",
    y: "318.77474"
  },
  BS: {
    parent_id: "BS",
    x: "583.65894",
    y: "323.17622"
  },
  KM: {
    parent_id: "KM",
    x: "1287.9838",
    y: "571.29094"
  },
  CV: {
    parent_id: "CV",
    x: "835.85297",
    y: "399.43428"
  },
  CY: {
    parent_id: "CY",
    x: "1150.5603",
    y: "275.19179"
  },
  FK: {
    parent_id: "FK",
    x: "708.01129",
    y: "820.18181"
  },
  FO: {
    parent_id: "FO",
    x: "956.7016",
    y: "100.08715"
  },
  FM: {
    parent_id: "FM",
    x: "1908.8958",
    y: "457.59999"
  },
  GU: {
    parent_id: "GU",
    x: "1800.5416",
    y: "424.05693"
  },
  MV: {
    parent_id: "MV",
    x: "1402.3335",
    y: "466.851"
  },
  MH: {
    parent_id: "MH",
    x: "1953.9998",
    y: "446.86858"
  },
  MT: {
    parent_id: "MT",
    x: "1078.0309",
    y: "273.66631"
  },
  MP: {
    parent_id: "MP",
    x: "1816.5229",
    y: "391.22719"
  },
  MU: {
    parent_id: "MU",
    x: "1306.3994",
    y: "622.88561"
  },
  NC: {
    parent_id: "NC",
    x: "1897.2679",
    y: "647.59911",
    color: "rgba(0,0,0,.3)"
  },
  NR: {
    parent_id: "NR",
    x: "1933.4666",
    y: "495.86855"
  },
  PW: {
    parent_id: "PW",
    x: "1746.8994",
    y: "445.18715"
  },
  PR: {
    parent_id: "PR",
    x: "636.83417",
    y: "372.98149"
  },
  PF: {
    parent_id: "PF",
    x: "152.11642",
    y: "605.18498"
  },
  SB: {
    parent_id: "SB",
    x: "1891.2991",
    y: "541.60198"
  },
  ST: {
    parent_id: "ST",
    x: "1000.5636",
    y: "508.20927"
  },
  SC: {
    parent_id: "SC",
    x: "1273.3285",
    y: "550.18498"
  },
  TO: {
    parent_id: "TO",
    x: "13.749858",
    y: "644.78185"
  },
  TV: {
    parent_id: "TV",
    x: "2000.0652",
    y: "547.10057"
  },
  VU: {
    parent_id: "VU",
    x: "1935.8312",
    y: "587.4688"
  },
  WS: {
    parent_id: "WS",
    x: "15.366571",
    y: "580.80138"
  },
  IC: {
    parent_id: "IC",
    x: "900.48877",
    y: "309.38716"
  },
  YT: {
    parent_id: "YT",
    x: "1289.5737",
    y: "593.911"
  },
  RE: {
    parent_id: "RE",
    x: "1295.5007",
    y: "644.31065"
  },
  FJ: {
    parent_id: "FJ",
    x: "1980.5682",
    y: "598.20201"
  },
  SG: {
    parent_id: "SG",
    x: "1583.4548",
    y: "507.78105"
  }
};
var NEXUS_PRODUCTS;
var mapProducts;
const getCurrentMapProducts = function() {
  return mapProducts;
};
var genratePopupHtml = function(details) {
  var li = "";
  let servicesCount = 0;
  let col = 4;
  Object.keys(details).forEach(operator => {
    servicesCount = servicesCount + details[operator].length;
  });

  for (let operator of Object.keys(details).sort()) {
    if (servicesCount <= 5) {
      col = 12;
    } else if (5 < servicesCount && servicesCount <= 10) {
      col = 6;
    } else if (10 < servicesCount && servicesCount <= 30) {
      col = 4;
    } else {
      col = 3;
    }
    for (let service of details[operator])
      li =
        li +
        `<div class="popup-col col-${col}">
        <span class="padding-r-3">${operator}</span><i class="panel-icon fas fa-${
          ICONS[
            service
              .toString()
              .toLowerCase()
              .replace(" ", "")
          ]
        }"></i></div>`;
  }

  return `<div class="container "><div class="popup-container"><div class="row pop-up ">${li}</div></div>
    <style>
      .popup-container > * > *{
        border: none!important;
        border-top: 1px solid #eee!important;
        background: transparent!important;
        border-radius: 0!important;
        padding-top: 15px!important;
        font-size: .85rem!important;
      }
      .popup-container i {
        font-size: 1rem;
      }
    </style>
  </div> 
  `;
};
const setLiveStatesAttr = function() {
  let liveCountries = Object.keys(mapProducts);
  for (let isoCode of liveCountries) {
    try {
      window.simplemaps_worldmap_mapdata.state_specific[
        MAPPING_ISO_CODE[isoCode]
      ].color = "#69be29";
      window.simplemaps_worldmap_mapdata.state_specific[
        MAPPING_ISO_CODE[isoCode]
      ].url = "#/map/" + isoCode + "#" + isoCode;
      window.simplemaps_worldmap_mapdata.state_specific[
        MAPPING_ISO_CODE[isoCode]
      ].description = genratePopupHtml(
        mapProducts[isoCode].operatorsMapServices
      );
      //set labels:
      window.simplemaps_worldmap_mapdata.labels[MAPPING_ISO_CODE[isoCode]] =
        all_labels[MAPPING_ISO_CODE[isoCode]];
    } catch (err) {
      console.log("not found", isoCode, MAPPING_ISO_CODE[isoCode], err);
    }
  }
};

const start = function() {
  NEXUS_PRODUCTS = getProducts();
  mapProducts = NEXUS_PRODUCTS;
  load();
};
const load = function() {
  setLiveStatesAttr();
  window.simplemaps_worldmap.load();
};
const resetStatesAttr = function() {
  Object.keys(window.simplemaps_worldmap_mapdata.state_specific).forEach(
    country => {
      window.simplemaps_worldmap_mapdata.state_specific[country].color =
        "default";
      window.simplemaps_worldmap_mapdata.state_specific[country].url =
        "default";
      window.simplemaps_worldmap_mapdata.state_specific[country].description =
        "default";
    }
  );
};
const resetMap = function() {
  mapProducts = NEXUS_PRODUCTS;
  load();
};
const toggleZoom = function(checked) {
  window.simplemaps_worldmap_mapdata.main_settings.zoom = checked
    ? "yes"
    : "no";
  window.simplemaps_worldmap.load();
};
const unselectAll = function() {
  mapProducts = [];
  resetStatesAttr();
  load();
};
const filterByServices = function(targetServices) {
  let filteredCountries = {};
  Object.keys(NEXUS_PRODUCTS)
    .filter(country => {
      return NEXUS_PRODUCTS[country].services.some(service => {
        return targetServices.includes(service);
      });
    })
    .forEach(country => {
      filteredCountries[country] = NEXUS_PRODUCTS[country];
    });
  return filteredCountries;
};
const filterByCountries = function(targetIsoCodes) {
  let filteredCountries = {};
  targetIsoCodes.forEach(
    iso_code => (filteredCountries[iso_code] = NEXUS_PRODUCTS[iso_code])
  );
  return filteredCountries;
};
const filterByOperators = function(targetOperators) {
  let filteredCountries = {};
  Object.keys(NEXUS_PRODUCTS)
    .filter(country => {
      return NEXUS_PRODUCTS[country].operators.some(operator => {
        return targetOperators.includes(operator);
      });
    })
    .forEach(country => {
      filteredCountries[country] = NEXUS_PRODUCTS[country];
    });
  return filteredCountries;
};
const filterByRegion = function(targetRegions) {
  let filteredRegions = {};
  Object.keys(NEXUS_PRODUCTS)
    .filter(country => {
      return targetRegions.includes(NEXUS_PRODUCTS[country].region);
    })
    .forEach(country => {
      filteredRegions[country] = NEXUS_PRODUCTS[country];
    });
  return filteredRegions;
};
const applyFilter = function(mapFilter) {
  let filteredCountries = Object.keys(NEXUS_PRODUCTS);
  if (mapFilter.services.length > 0) {
    filteredCountries = R.intersection(
      filteredCountries,
      Object.keys(filterByServices(mapFilter.services))
    );
  }
  if (mapFilter.countries.length > 0) {
    filteredCountries = R.intersection(
      filteredCountries,
      Object.keys(filterByCountries(mapFilter.countries))
    );
  }
  if (mapFilter.operators.length > 0) {
    filteredCountries = R.intersection(
      filteredCountries,
      Object.keys(filterByOperators(mapFilter.operators))
    );
  }
  if (mapFilter.regions.length > 0) {
    filteredCountries = R.intersection(
      filteredCountries,
      Object.keys(filterByRegion(mapFilter.regions))
    );
  }
  mapProducts = {};
  filteredCountries.forEach(isoCode => {
    mapProducts[isoCode] = NEXUS_PRODUCTS[isoCode];
  });
  resetStatesAttr();
  load();
};
const showLocations = function(toggle) {
  window.simplemaps_worldmap_mapdata["locations"] = toggle ? locations : {};
  load();
};
const swapShowDetailsMethod = function(method) {
  //method either on_hover or on_click
  window.simplemaps_worldmap_mapdata.main_settings.popups = method;
  load();
};

export {
  start,
  load,
  setLiveStatesAttr,
  resetStatesAttr,
  resetMap,
  toggleZoom,
  unselectAll,
  applyFilter,
  mapProducts,
  showLocations,
  swapShowDetailsMethod,
  getCurrentMapProducts
};
